// @flow

import React, { Component } from 'react';
import '../../src/App.css';

type State = {};
type Props = {
  progress: number
};

class Progress extends Component<Props, State> {
  render() {
    return (
      <div className="progress">
        <div
          style={{ width: `${this.props.progress}%` }}
          className="progress__bar"
        />
      </div>
    );
  }
}

export default Progress;



// WEBPACK FOOTER //
// ./src/components/Progress.js